module.exports = __webpack_public_path__ + "img/House_2_Low_Set.a409f131.jpg";